export default "__VITE_ASSET__BfTmkLta__"